import Board from './board.js';

export default class UTTT {
  constructor() {
    this._ub = [
      [new Board(), new Board(), new Board()],
      [new Board(), new Board(), new Board()],
      [new Board(), new Board(), new Board()]
    ];
    this._result = 'ongoing';
    this._decidedCount = 0;
    this._turn = 'X';
    this._moves = [];
    this._bigBasedOnLastMove = null;
    this._lastMove = null;
    this._allAllowed = true;
    this._representations = [];
    this._bigRepresentations = [];
    this.pushToRepresentations();
    this.pushToBigRepresentations();
  }

  pushToRepresentations() {
    let rep = [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0]
    ]; // zeroes are just demo, soon to be replaced
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        rep[i][j] = this._ub[i][j].getBoardCopy();
      }
    }
    this._representations.push(rep);
  }
  pushToBigRepresentations() {
    let rep = [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0]
    ];
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        rep[i][j] = this._ub[i][j].getResult();
        if (rep[i][j] != 'X' && rep[i][j] != 'O') {
          rep[i][j] = '-';
        }
      }
    }
    this._bigRepresentations.push(rep);
  }

  makeMove(x, y, a, b) {
    if (typeof (x) != 'number' || typeof (y) != 'number' || typeof (a) != 'number' || typeof (b) != 'number') {
      console.log("ERROR:invalid move input")
      return false;
    }
    if (this._result != 'ongoing') {
      console.log("ERROR:cant move when game is decided")
      return false;
    }
    if (x < 0 || x > 2 || y < 0 || y > 2 || a < 0 || a > 2 || b < 0 || b > 2) {
      console.log("ERROR:out of bound move")
      return false;
    }
    if (!this._allAllowed) {
      if (this._bigBasedOnLastMove[0] != x || this._bigBasedOnLastMove[1] != y) {
        console.log("ERROR: move not allowed on that board")
        return false;
      }
    }
    if (this._ub[x][y].makeMove(a, b, this._turn)) {
      this._bigBasedOnLastMove = [a, b];
      if (this._ub[x][y].getResult() != 'ongoing') {
        this._decidedCount++;
      }
      if (this._ub[a][b].getResult() != 'ongoing') {
        this._allAllowed = true;
      } else {
        this._allAllowed = false;
      }
      if (this._checkIfWon(this._turn)) {
        this._result = this._turn;
      } else {
        if (this._decidedCount == 9) {
          this._result = 'draw';
        }
      }
      this._turn = (this._turn == "X") ? ("O") : ("X");
      this._moves.push([x, y, a, b]);
      this._lastMove = [x, y, a, b];
      this.pushToRepresentations();
      this.pushToBigRepresentations();
      return true;
    } else {
      return false;
    }
  }

  _checkIfWon(who) {
    // check rows
    for (let i = 0; i < 3; i++) {
      if ((this._ub[i][0].getResult() == who) && (this._ub[i][1].getResult() == who) && (this._ub[i][2].getResult() == who)) {
        return true;
      }
    }
    // check columns
    for (let i = 0; i < 3; i++) {
      if ((this._ub[0][i].getResult() == who) && (this._ub[1][i].getResult() == who) && (this._ub[2][i].getResult() == who)) {
        return true;
      }
    }
    // check first diagonal
    if ((this._ub[0][0].getResult() == who) && (this._ub[1][1].getResult() == who) && (this._ub[2][2].getResult() == who)) {
      return true;
    }
    // check second diagonal
    if ((this._ub[0][2].getResult() == who) && (this._ub[1][1].getResult() == who) && (this._ub[2][0].getResult() == who)) {
      return true;
    }
    return false;
  }

  isAllAllowed() {
    return this._allAllowed;
  }

  printBoard() {
    console.log(` result =  ${this._result} `);
    console.log(` decided count =  ${this._decidedCount} `);
    console.log(` turn = ${this._turn} `);
    console.log(` last move = ${this._bigBasedOnLastMove} `);
    console.log(` all allowed = ${this._allAllowed} `);

    console.log('+++++');

    let output = '';
    output = output + this._ub[0][0].getSquare(0, 0);
    output = output + this._ub[0][0].getSquare(0, 1);
    output = output + this._ub[0][0].getSquare(0, 2);
    output = output + ' ';
    output = output + this._ub[0][1].getSquare(0, 0);
    output = output + this._ub[0][1].getSquare(0, 1);
    output = output + this._ub[0][1].getSquare(0, 2);
    output = output + ' ';
    output = output + this._ub[0][2].getSquare(0, 0);
    output = output + this._ub[0][2].getSquare(0, 1);
    output = output + this._ub[0][2].getSquare(0, 2);
    output = output + ' ';
    console.log(output);

    output = '';
    output = output + this._ub[0][0].getSquare(1, 0);
    output = output + this._ub[0][0].getSquare(1, 1);
    output = output + this._ub[0][0].getSquare(1, 2);
    output = output + ' ';
    output = output + this._ub[0][1].getSquare(1, 0);
    output = output + this._ub[0][1].getSquare(1, 1);
    output = output + this._ub[0][1].getSquare(1, 2);
    output = output + ' ';
    output = output + this._ub[0][2].getSquare(1, 0);
    output = output + this._ub[0][2].getSquare(1, 1);
    output = output + this._ub[0][2].getSquare(1, 2);
    output = output + ' ';
    console.log(output);

    output = '';
    output = output + this._ub[0][0].getSquare(2, 0);
    output = output + this._ub[0][0].getSquare(2, 1);
    output = output + this._ub[0][0].getSquare(2, 2);
    output = output + ' ';
    output = output + this._ub[0][1].getSquare(2, 0);
    output = output + this._ub[0][1].getSquare(2, 1);
    output = output + this._ub[0][1].getSquare(2, 2);
    output = output + ' ';
    output = output + this._ub[0][2].getSquare(2, 0);
    output = output + this._ub[0][2].getSquare(2, 1);
    output = output + this._ub[0][2].getSquare(2, 2);
    output = output + ' ';
    console.log(output);
    // --------------------
    console.log('+++++');
    output = '';
    output = output + this._ub[1][0].getSquare(0, 0);
    output = output + this._ub[1][0].getSquare(0, 1);
    output = output + this._ub[1][0].getSquare(0, 2);
    output = output + ' ';
    output = output + this._ub[1][1].getSquare(0, 0);
    output = output + this._ub[1][1].getSquare(0, 1);
    output = output + this._ub[1][1].getSquare(0, 2);
    output = output + ' ';
    output = output + this._ub[1][2].getSquare(0, 0);
    output = output + this._ub[1][2].getSquare(0, 1);
    output = output + this._ub[1][2].getSquare(0, 2);
    output = output + ' ';
    console.log(output);

    output = '';
    output = output + this._ub[1][0].getSquare(1, 0);
    output = output + this._ub[1][0].getSquare(1, 1);
    output = output + this._ub[1][0].getSquare(1, 2);
    output = output + ' ';
    output = output + this._ub[1][1].getSquare(1, 0);
    output = output + this._ub[1][1].getSquare(1, 1);
    output = output + this._ub[1][1].getSquare(1, 2);
    output = output + ' ';
    output = output + this._ub[1][2].getSquare(1, 0);
    output = output + this._ub[1][2].getSquare(1, 1);
    output = output + this._ub[1][2].getSquare(1, 2);
    output = output + ' ';
    console.log(output);

    output = '';
    output = output + this._ub[1][0].getSquare(2, 0);
    output = output + this._ub[1][0].getSquare(2, 1);
    output = output + this._ub[1][0].getSquare(2, 2);
    output = output + ' ';
    output = output + this._ub[1][1].getSquare(2, 0);
    output = output + this._ub[1][1].getSquare(2, 1);
    output = output + this._ub[1][1].getSquare(2, 2);
    output = output + ' ';
    output = output + this._ub[1][2].getSquare(2, 0);
    output = output + this._ub[1][2].getSquare(2, 1);
    output = output + this._ub[1][2].getSquare(2, 2);
    output = output + ' ';
    console.log(output);
    // --------------------
    console.log('+++++');
    output = '';
    output = output + this._ub[2][0].getSquare(0, 0);
    output = output + this._ub[2][0].getSquare(0, 1);
    output = output + this._ub[2][0].getSquare(0, 2);
    output = output + ' ';
    output = output + this._ub[2][1].getSquare(0, 0);
    output = output + this._ub[2][1].getSquare(0, 1);
    output = output + this._ub[2][1].getSquare(0, 2);
    output = output + ' ';
    output = output + this._ub[2][2].getSquare(0, 0);
    output = output + this._ub[2][2].getSquare(0, 1);
    output = output + this._ub[2][2].getSquare(0, 2);
    output = output + ' ';
    console.log(output);

    output = '';
    output = output + this._ub[2][0].getSquare(1, 0);
    output = output + this._ub[2][0].getSquare(1, 1);
    output = output + this._ub[2][0].getSquare(1, 2);
    output = output + ' ';
    output = output + this._ub[2][1].getSquare(1, 0);
    output = output + this._ub[2][1].getSquare(1, 1);
    output = output + this._ub[2][1].getSquare(1, 2);
    output = output + ' ';
    output = output + this._ub[2][2].getSquare(1, 0);
    output = output + this._ub[2][2].getSquare(1, 1);
    output = output + this._ub[2][2].getSquare(1, 2);
    output = output + ' ';
    console.log(output);

    output = '';
    output = output + this._ub[2][0].getSquare(2, 0);
    output = output + this._ub[2][0].getSquare(2, 1);
    output = output + this._ub[2][0].getSquare(2, 2);
    output = output + ' ';
    output = output + this._ub[2][1].getSquare(2, 0);
    output = output + this._ub[2][1].getSquare(2, 1);
    output = output + this._ub[2][1].getSquare(2, 2);
    output = output + ' ';
    output = output + this._ub[2][2].getSquare(2, 0);
    output = output + this._ub[2][2].getSquare(2, 1);
    output = output + this._ub[2][2].getSquare(2, 2);
    output = output + ' ';
    console.log(output);
  }

  getResult() {
    return this._result;
  }

  getNextTurn() {
    return this._turn;
  }

  getRepresentations() {
    return this._representations;
  }
  getBigRepresentations() {
    return this._bigRepresentations;
  }
  getLastMove() {
    return this._lastMove;
  }
}